import { Component, OnInit, Inject, Input } from '@angular/core';
import { HomeService } from '../home.service';
@Component({
  selector: 'app-our-portfolio',
  templateUrl: './our-portfolio.component.html',
  styleUrls: ['./our-portfolio.component.css']
})
export class OurPortfolioComponent implements OnInit {

  constructor(@Inject(HomeService) private homeService: HomeService) { }
  portFolios: any;

  ngOnInit() {
    // this.homeService.portfolioObservable$.subscribe((data) => {
    //   console.log('in ported');
    //   this.portFolios = data;
    //   console.log(this.portFolios);
    // });  
    this.portFolios = [
      {
        'id': 4018,
        'title': "Basketball",
        'industry': "Sports App",
        'feature_image': "assets/images/portfolio/Basketball-1.jpg"
      },
      {
        'id': 3813,
        'title': "CNANetNurse",
        'industry': "HealthCare App",
        'feature_image': "assets/images/portfolio/CNANETNURSE-1.jpg"
      },
      {
        'id': 3866,
        'title': "WeightNot",
        'industry': "Fitness App",
        'feature_image': "assets/images/portfolio/WEIGHTNOT-2.jpg"
      }
      , {
        'id': 3726,
        'title': "PerFit-HR",
        'industry': "Business",
        'feature_image': "assets/images/portfolio/PERFIT-HR-2.jpg"
      },
      {
        'id': 3795,
        'title': "Bubble",
        'industry': "Social ",
        'feature_image': "assets/images/portfolio/BUBBLE-3.jpg"
      },
      {
        'id': 3711,
        'title': "TVS",
        'industry': "Finance",
        'feature_image': "assets/images/portfolio/TVS-1.jpg"
      },
      {
        'id': 3785,
        'title': "Roula",
        'industry': "Bike Renting",
        'feature_image': "assets/images/portfolio/ROULA-1.jpg"
      },
      {
        'id': 3765,
        'title': "3c-Dental",
        'industry': "Healthcare",
        'feature_image': "assets/images/portfolio/3C-DENTAL-2.jpg"
      }
    ];

  }
}
